import React, { memo, useCallback, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSharedValue } from 'react-native-reanimated';
import Text from 'design-system/Text';
import Squircle from 'design-system/Squircle';
import { AppView, Button, NavigationHeader, Spacer, rem } from 'design-system';
import useColors from 'hooks/useColors';
import IconWarning from 'features/invest/icons/IconWarning';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectMissingRequiredNationalityIdentifiers } from 'features/invest/reducers/selectors';
import { useAppStore } from 'store/hooks';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { blockInvestOnboardingOnWeb } from 'features/invest/webGate';
const ExtraInformationNeededBlock = () => {
    const colors = useColors();
    const store = useAppStore();
    const scrollY = useSharedValue(0);
    const navigation = useMainStackNavigation();
    const outputColors = useMemo(() => [colors.background.light, colors.cards.onDark], [colors.background.light, colors.cards.onDark]);
    const handleReview = useCallback(() => {
        if (blockInvestOnboardingOnWeb())
            return;
        const requiredNationalIdentifiers = selectMissingRequiredNationalityIdentifiers(store.getState());
        if (requiredNationalIdentifiers?.[0]) {
            navigation.navigateDeprecated('InvestExtraInsurance', {
                identifier: requiredNationalIdentifiers?.[0],
            });
        }
    }, []);
    return (<AppView type="primary">
      <NavigationHeader isInTab scrollY={scrollY} hideTitleOnScroll regularTitleHeight outputColors={outputColors} rightContent={<View style={styles.flexEnd}>
            <HelpScreenButton />
          </View>}/>
      <View style={styles.wrapper}>
        <View style={styles.container}>
          <Squircle height={rem(100)} width={rem(100)}>
            <IconWarning />
          </Squircle>

          <Spacer.H16 />
          <Spacer.H16 />

          <Text centered Text-24>
            Additional information required
          </Text>
          <Spacer.H8 />
          <Text centered TextThin-16 Secondary>
            {'Please update your information to continue\xa0investing.\n\nWe need to verify your details for regulatory\xa0purposes.'}
          </Text>
        </View>
        <Button errorPrimary title="Review" onPress={handleReview}/>
        <Spacer.H16 />
      </View>
    </AppView>);
};
export default memo(ExtraInformationNeededBlock);
const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    wrapper: {
        flex: 1,
        paddingHorizontal: rem(16),
    },
    flexEnd: {
        paddingRight: 15,
        alignItems: 'flex-end',
    },
});
